var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timeline-container box" },
    [
      _vm.showTimeline
        ? [
            _c(
              "b-steps",
              {
                staticClass: "is-align-self-center steps",
                attrs: {
                  "has-navigation": false,
                  "label-position": _vm.labelPosition,
                  "mobile-mode": "minimalist",
                  position: _vm.position,
                  horizontal: "",
                  size: "is-small",
                  type: "is-success",
                },
                model: {
                  value: _vm.currentStep,
                  callback: function ($$v) {
                    _vm.currentStep = $$v
                  },
                  expression: "currentStep",
                },
              },
              [
                _vm._l(
                  _vm.timelineSteps[_vm.currentWorkflow],
                  function (step, index) {
                    return [
                      step.included !== false
                        ? _c(
                            "b-step-item",
                            {
                              key: index,
                              staticClass: "step-content",
                              attrs: {
                                clickable: false,
                                icon: _vm.getStepIcon(step),
                                label: step.label,
                                rounded: false,
                                value: step.label,
                              },
                            },
                            [
                              !_vm.deviceIsMobile
                                ? _c(
                                    "div",
                                    { staticClass: "current-step-description" },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(step.text) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }
                ),
              ],
              2
            ),
          ]
        : [
            _c(
              "div",
              { staticClass: "current-step-description placeholder-status" },
              [_vm._v("\n      This project has no timeline.\n    ")]
            ),
          ],
      _vm._v(" "),
      _c("div", { staticClass: "separator" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "due-date-container" },
        [
          _c(
            "b-field",
            {
              attrs: {
                label: "Due Date",
                "custom-class": "has-text-black is-size-5",
                expanded: "",
              },
            },
            [
              _c("p", { staticClass: "control is-size-6" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.estimateDueDateFormatted) +
                    "\n      "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }